/**
 * 매장·예약 관련 시간 계산.
 * store route 전용 util.
 */

import { getDayOfWeekIndex } from "../../../utils/reserve-time";

/** 요일별 예약 시간 (월=0, 일=6) */
export interface ReserveTimeDay {
  start?: string;
  end?: string;
}

/**
 * 마감 시간(closingHours, HH:mm)까지 남은 시간을 HH:MM:SS 문자열로 반환한다.
 */
export function getTimeLeftFromClosingHours(closingHours: string): string {
  const currentTime = new Date();
  const closingTime = new Date();
  const [h, m] = (closingHours?.split(":") ?? ["0", "0"]).map(Number);
  closingTime.setHours(h, m, 0);
  const diff = closingTime.getTime() - currentTime.getTime();
  if (diff <= 0) return "00:00:00";
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

/**
 * 지정한 날짜 오프셋의 예약 시작 시간 30분 전 시간(HH:mm)을 반환한다.
 */
export function calculateReserveTimeBefore30Minutes(
  dayOffset: number,
  reserveTime: Record<string, ReserveTimeDay> | null | undefined
): string {
  const date = new Date();
  date.setDate(date.getDate() + dayOffset);
  const dayKey = getDayOfWeekIndex(date);
  const start = reserveTime?.[dayKey]?.start;
  if (!start) return "";
  const [startHour, startMinute] = start.split(":").map(Number);
  date.setHours(startHour, startMinute - 30);
  return `${date.getHours().toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
}
